import React from 'react'

import Img, { getImageUrl, Sizes } from '../components/blocks/editable/Img'

import { Helmet } from "react-helmet";

import InnerHTML from "dangerously-set-html-content";
import {InView} from "react-intersection-observer";

import Div from '../components/layouts/Div'

import General from '../utils/General'
import Backend from '../utils/Backend'
import ScriptCache from '../utils/ScriptCache'
import CartUtil from '../utils/Cart'
import Currency from '../utils/Currency'
import Notify from '../utils/Notify'
import Navigation from "../utils/Navigation";
import ProductSettingsModal from "../components/modal/ProductSettingsModal";
import {RotatingLines} from "react-loader-spinner";
import Event from "../utils/Event";
import PopupManagerModal, { StorefrontPopupWrapper } from '../components/modal/PopupManagerModal';
import BadgeBlock from "../components/BadgeBlock";
import SafeHtml from "../components/SafeHtml";
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import AuthManager from '../utils/AuthManager';
import ActionToolbar from '../components/ActionToolbar';
import SEOTag from "../components/SEOTag";
import { getHsaBadge } from '../components/Menu';

export default class Cart extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      key: 0,
      quantity: 1,
      cart: props.cart,
      page: props.page,
      website: window.CURRENT_WEBSITE,
      editable: props.editable,
      error: null,
      showPopupManagerModal: false,
      openBundleIds: {},
      shippable: null
    }

    this._updateWebsite = General.debounce(
      () => {
        Backend.updateWebsite({
          slug: this.state.website.slug,
          extra: this.state.website.extra,
          checkout_type: this.state.website.checkout_type,
        });
        this.setState({
          key: this.state.key + 1
        })
      },
      1000,
      false
    );
  }

  componentDidMount() {
    this._setup()
    Event.on('WEBSITE_UPDATED', () => {
      this.setState({
        website: window.CURRENT_WEBSITE
      })
    });
    Event.on('WEBSITE_CHANGE_UPDATED', (website) => {
      this.setState({
        website: window.CURRENT_WEBSITE
      }, this._setup)
    });
  }

  componentWillReceiveProps(nextProps){
    this.setState({
      ...nextProps,
      error: null
    })
  }

  componentDidUpdate(){
    const insureShipProductId = window?.CURRENT_CAMPAIGN?.insureShipProductId;
    const shippable = CartUtil.isCartShippable([insureShipProductId]) || false;
    if (shippable !== this.state.shippable) {
      this.setState({
        shippable
      });
      if (!shippable) {
        const insureShipProduct = this.state?.cart?.items?.find((o) => o?.product?.campaignProductId == insureShipProductId);
        if (insureShipProduct) {
          const { customMessage, frequency, product, quantity } = insureShipProduct;
          CartUtil.remove(product, null, customMessage, quantity, frequency);
        }
      }
    }
  }

  componentWillUnmount(){
    Event.off('WEBSITE_UPDATED');
    Event.off('WEBSITE_CHANGE_UPDATED');
  }

  _setup(){
    let {
      website,
    } = this.state

    if(website.extra?.product_page_settings?.cart_page_product){
      this._loadProduct(website.extra?.product_page_settings?.cart_page_product.productId)
    } else {
      this.setState({
        featuredProduct: null,
        variantOptions: null,
        customMessageOptions: null
      })
    }

    this._loadJs()
  }

  _loadProduct(productId){
    this.setState({ loading: true })
    Backend.getProducts(productId).then(products => {
      let featuredProduct = products[0]
      let variantOptions = CartUtil.getOptions(featuredProduct)
      let customMessageOptions = CartUtil.getCustomMessageOptions(featuredProduct)
      this.setState({variantOptions, featuredProduct, customMessageOptions, loading: false}, () => this._loadJs())
    })
  }

  _loadJs(){
    ScriptCache.loadDefaults()
    setTimeout(() => {
      General.updateAll()
    }, 300)
  }

  _update(website, callback) {
    let pageSize = website.extra?.product_page_settings?.product_page_count || this.state.pageSize;
    this.setState({ website, pageSize }, () => {
      if (callback) {
        callback();
      }
      this._updateWebsite();
    });
  }

  async _onDashboardClicked() {
    this.setState({savingPage: true})
    await Backend.savePage();
    General.openEditFunnel();
  }
  toggleBundleDisplay = (id) => {
    this.setState(prevState => {
      const isOpen = prevState.openBundleIds[id];
      return {
        openBundleIds: {
          ...prevState.openBundleIds,
          [id]: !isOpen
        }
      };
    });
  };
  _renderCartItems(cart){
    const { website } = this.state
    const currency = cart.campaign?.currencySymbol

    if(!cart) return null
    const dividerStyle = {
      borderColor: website?.extra?.product_page_settings?.cart_divider_color
    }
    const textStyle = {
      color: website?.extra?.product_page_settings?.cart_text_color
    }
    const priceStyle = {
      color: website?.extra?.product_page_settings?.cart_price_color
    }
    return cart.items.map((item, index) => {
      let variantDetailId = item.ccCartKey.split('.')[1]
      let product = item.product
      let quantity = item.quantity
      let frequency = item.frequency

      if(!product) return

      let price = product.cycle1_price

      let variant = product.variants?.find(productVariant => {
        return productVariant.variantDetailId === parseInt(variantDetailId)
      })

      if(variant && variant.price) {
        price = variant.price
      }
      const productUrl = Navigation.getProductUrl(product.campaignProductId)
      const { openBundleIds } = this.state;
      const bundleStringArray = JSON.parse(sessionStorage.getItem("bundleStringArray") || "{}");
      const variantList = bundleStringArray[product?.campaignProductId]?.split("|")?.splice("2") || [];
      const insureshipProduct = window?.CURRENT_CAMPAIGN?.insureShipProductId == product.campaignProductId;
      return (
        <div className="product-item py-5" style={dividerStyle}>
          <div className="row">
            <div className="col-8">
              <div className="d-flex align-items-center">
                <div className="img m-0" style ={{ backgroundImage: "url("+product.imageUrl+")" } } />
                <div className="ml-3" style={textStyle}>
                  <a
                    className="m-0 h5 title pr-xl-2"
                    href={productUrl}
                    onClick={() => {
                      General.setLocationHref(productUrl)
                    }}
                    style={textStyle}
                  >
                    {product.productName}
                  </a>
                  {(() => {
                    const badge = getHsaBadge(product);
                    return badge ? <span dangerouslySetInnerHTML={{ __html: badge }} /> : null;
                  })()}
                  {product.isVariantBundle ? <span
                    style={{cursor: "pointer", userSelect: "none", marginLeft: "10px", ...textStyle}}
                    onClick={() => this.toggleBundleDisplay(product.campaignProductId)}
                    aria-label={openBundleIds[product.campaignProductId] ? "Hide bundle details" : "Show bundle details"}
                  >
                    {openBundleIds[product.campaignProductId] ? <FaChevronUp/> : <FaChevronDown/>}
                  </span> : null}
                  {
                    variant &&
                    <div className="variant" style={textStyle}>Variant: {variant.title}</div>
                  }
                  {
                    item.customMessage?.map(customMessage => {
                      let [key, value] = customMessage.split(':')
                      return (
                        <div className="quantity">{General.toTitleCase(key)}: {value}</div>
                      )
                    })
                  }
                  {
                    item.frequency &&
                    <div className="quantity">Frequency: {General.toTitleCase(item.frequency)}</div>
                  }
                </div>
              </div>
            </div>
            <div className="col d-flex align-items-center justify-content-between">
              <div className={`input-number col-auto p-0 ${insureshipProduct ? "input-control-opacity" : ""}`}>
                <input
                  type="number"
                  name="quantity"
                  placeholder="Quantity"
                  value={quantity}
                  min="1"
                />
                <div className="input-number__controls">
                <span
                  className="input-number__increase"
                  onClick={() => {
                    if (product.isVariantBundle || insureshipProduct) return;
                    CartUtil.add(product, variant, item.customMessage, 1, frequency)
                      .then((cart) => {
                        this.setState({ cart });
                        this.props.onUpdatedCart(cart);
                      })
                      .catch((error) => {
                        Notify.error(error.message);
                      });
                  }}
                >
                  <i className="stack-up-open"/>
                </span>
                  <span
                    className="input-number__decrease"
                    onClick={() => {
                      if (product?.isVariantBundle || insureshipProduct) return;
                      CartUtil.remove(product, variant, item.customMessage, 1, frequency)
                        .then((cart) => {
                          this.setState({ cart });
                          this.props.onUpdatedCart(cart);
                        })
                        .catch((error) => {
                          Notify.error(error.message);
                        });
                    }}
                  >
                  <i className="stack-down-open"/>
                </span>
                </div>
              </div>
              <div className="col-2 p-0 delete text-center">
                <a
                  href="javascript:void(0);"
                  className={`material-icons ${insureshipProduct ? " d-none" : ""}`}
                  onClick={() => {
                    CartUtil.remove(product, variant, item.customMessage, quantity, frequency)
                      .then((cart) => {
                        this.setState({ cart });
                        this.props.onUpdatedCart(cart);
                        const bundleItems = JSON.parse(sessionStorage.getItem("bundleItems") || "{}");
                        if (product?.campaignProductId && bundleItems[product.campaignProductId]) {
                          delete bundleItems[product.campaignProductId];
                          sessionStorage.setItem("bundleItems", JSON.stringify(bundleItems));
                        }
                        const bundleStringArray = JSON.parse(sessionStorage.getItem("bundleStringArray") || "{}");
                        if (product?.campaignProductId && bundleStringArray[product.campaignProductId]) {
                          delete bundleStringArray[product.campaignProductId];
                          sessionStorage.setItem("bundleStringArray", JSON.stringify(bundleStringArray));
                        }
                      })
                      .catch((error) => {
                        Notify.error(error.message);
                      });
                  }}
                >
                  delete
                </a>
              </div>
              <span className="col p-0 text-right price" style={priceStyle}>{ Currency.toFormat(item.total) }</span>
            </div>
          </div>
          {product.isVariantBundle ? <div>
            {openBundleIds[product.campaignProductId] && (
              <ul style={{marginTop: 8}}>
                {variantList.map((variant, idx) => (
                  <li key={idx} style={{lineHeight: "1.5em"}}>
                    {variant && variant}
                  </li>
                ))}
              </ul>
            )}
          </div> : null}
        </div>
      )
    })
  }

  _renderCart(){
    let {
      cart,
      website
    } = this.state

    const currency = cart.campaign?.currencySymbol;

    function goToPreviousPage() {
      const trail = JSON.parse(sessionStorage.getItem("breadcrumbTrail") || "[]");
      const currentIndex = parseInt(sessionStorage.getItem("breadcrumbTrailIndex") || trail.length - 1);

      if (trail.length > 1 && currentIndex > 0) {
        const previousPage = trail[currentIndex - 1];
        sessionStorage.setItem("breadcrumbTrailIndex", currentIndex - 1);
        General.setLocationHref(previousPage.url);
      } else {
        General.setLocationHref(Navigation.getUrl("/"));
      }
    }
    const textStyle = {
      color: website?.extra?.product_page_settings?.cart_text_color
    }
    const priceStyle = {
      color: website?.extra?.product_page_settings?.cart_price_color
    }
    const labelStyle = {
      color: website?.extra?.product_page_settings?.cart_label_color
    }
    const subLabelStyle = {
      color: website?.extra?.product_page_settings?.cart_sub_label_color
    }
    const borderStyle = {
      border: `2px solid ${website?.extra?.product_page_settings?.body_border_color}`,
      borderRadius: website?.extra?.product_page_settings?.body_border_style,
      backgroundColor: website?.extra?.product_page_settings?.cart_bg_color,
      padding: website?.extra?.product_page_settings?.cart_padding
    }
    return (
      <div key={cart.items.length} className="col-md-12 col-left">
        <div className="row">
          <div className="col-md-12">
            <div className="cart-total m-0" style={borderStyle}>
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <h2 className="mb-0" style={textStyle}>Your Cart</h2>
                </div>
                <div>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      goToPreviousPage();
                    }}
                    className="cursor-pointer"
                    style={{
                      textDecoration: 'underline',
                      ...textStyle
                    }}
                  >
                    Continue Shopping
                  </a>
                </div>
              </div>

              { this._renderCartItems(cart) }
              <hr style={{borderColor: website?.extra?.product_page_settings?.cart_divider_color}}/>
              <div className="row m-md-b-0">
                <div className="col-6"/>
                <div className="col-6 d-flex align-items-center justify-content-end text-right">
                  <span className="h3 mb-0 mr-3" style={labelStyle}>Estimated Total</span>
                  <span className="h4 mb-0" style={priceStyle}>{ Currency.toFormat(cart.subtotal) }</span>
                </div>
              </div>
              <div className="row m-md-b-0 mt-2">
                <div className="col-6"/>
                <div className="col-6 text-right">
                  {
                    cart.items.length > 0 &&
                    <a
                      className="btn btn--primary type--uppercase btn--lg"
                      onClick={() => {
                        const url = website.extra?.product_page_settings?.checkout_url
                        if(!url) {
                          Notify.error("Checkout url not set, please contact the site owner")
                        }else if(window.IS_EDIT_MODE){
                          Notify.error("Checkout disabled in edit mode")
                        }else if(url) {
                          General.setLocationHref(Navigation.getUrl(url));
                        }
                      }}
                    >
                      <span className="btn__text">Checkout</span>
                    </a>
                  }
                </div>
              </div>
              <div className="row m-md-b-0 mt-2">
                <div className="col-6"/>
                <div className="col-6 text-right">
                  <span className="h5 font-weight-light" style={subLabelStyle}>Taxes and shipping calculated at checkout</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  _renderMeta(){
    let {
      website
    } = this.state

    let favIconUrl = website.favicon ? website.favicon.original : "/favicon.ico"

    return (
      <Helmet>
        <title>{`Cart | ${website.name}`}</title>
        <meta name="description" content={ website.description } />
        <meta name="keywords" content={ website.keywords } />
        <link rel="icon" href={ favIconUrl }/>
      </Helmet>
    )
  }

  _renderSEO() {
    let { website } = this.state;
    if(website.seo_tag) {
      return (<SEOTag {...website.seo_tag} />);
    }
    return null;
  }

  _renderProductSettingsButton() {
    let {
      editable,
      savingPage,
      page,
      website
    } = this.state;

    if (!editable) {
      return;
    }

    let className = "btn-fixed-left-container ignore-user-set-font";

    return (
      <div className={className}>

        <div className="d-flex">
          <button
            className="btn"
            title="Back to Funnel"
            onClick={() => this._onDashboardClicked()}
          >
            <span className="btn__text">
              {
                savingPage ?
                  <RotatingLines
                    height={24}
                    width={"24"}
                    strokeColor={"#ffffff"}
                  />
                  :
                  <span className="material-icons">exit_to_app</span>
              }
              <span className="slide-text">Back to Funnel</span>
            </span>
          </button>
        </div>

        {/* Starts : Button 01 */}
        <div className="d-flex">
          <a
            className="btn styling-button"
            title="Cart Settings"
            onClick={() => this.setState({ showProductSettingsModal: true })}
          >
            <span className="btn__text">
              <span class="material-icons">brush_outline</span>
              <span class="slide-text">Cart Settings</span>
            </span>
          </a>
        </div>
        {/* End : Button 01 */}

        {/* Starts : Button 02 */}
        <div className="d-flex">
          <a
            className="btn styling-button"
            title="Styling"
            onClick={() => this.setState({showPopupManagerModal: true})}
          >
            <span className="btn__text">
              <span class="material-icons">wysiwyg</span>
              <span class="slide-text">Popup Manager</span>
            </span>
          </a>
          <div className="c-tool-tips six">
            {General.renderTourButtonTitle("right", "Popup Manager")}
          </div>
        </div>
        {/* End : Button 02 */}
        {/* Starts : Button 08 / 09 */}
        { (editable && AuthManager.accessToken) &&
          <>
            <ActionToolbar variant="right-bottom" page={page} website={website}/>
          </>
        }
        {/* End : Button 08 / 09 */}
      </div>
    );
  }

  _renderPrice(product) {
    let { website } = this.state;

    if (!product) {
      return "";
    }

    let price = product.cycle1_price
    let currency = window.CURRENT_CAMPAIGN?.currencySymbol

    if (product.on_sale) {
      return (
        <>
          <span
            className="h3 type--strikethrough m-0 pr-1"
            style={{ color: website.secondary_color }}
          >
            {Currency.toFormat(price)}
          </span>
          <span
            className="h3 m-0 pr-2"
            style={{ color: website.secondary_color }}
          >
            {Currency.toFormat(price)}
          </span>
        </>
      );
    }

    if(product.variants.length > 0){
      if(product.variants[0].price){
        price = product.variants[0].price
      }
    }

    return (
      <span
        className="h3 m-0 pr-2"
        style={{ color: website.secondary_color }}
      >
        {Currency.toFormat(price)}
      </span>
    );
  }

  _renderPopupManagerModal(){
    let {
      showPopupManagerModal,
      editable,
      website
    } = this.state

    return (
      <>
        {showPopupManagerModal && <PopupManagerModal
          show={showPopupManagerModal}
          onHide={() => this.setState({ showPopupManagerModal: false })}
          editable={editable}
          websitePopupCollection={website?.extra?.popup_collection || []}
          website={website}
        />}
      </>
    )
  }

  render(){
    let {
      key,
      quantity,
      website,
      featuredProduct,
      variantOptions,
      customMessageOptions
    } = this.state;

    let images = [{original: featuredProduct?.imageUrl}]

    let showAddCart = (variantOptions && Object.entries(variantOptions).length < 1) && (customMessageOptions && customMessageOptions.length < 1)

    let cartButtonText = "Add To Cart"
    if(window.CURRENT_WEBSITE.checkout_type === "instant"){
      cartButtonText = "Buy Now"
    }
    const productUrl = Navigation.getProductUrl(featuredProduct?.campaignProductId)
    return (
      <>
        <div className="main-container page product">
          { this._renderMeta() }
          {this._renderSEO()}
          <section style={{background: website?.extra?.product_page_settings?.body_bg_color}} className="cart-customer-details cart-checkout m-0">
            <Div
              className="container"
            >
              <div className="row justify-content-around">
                { this._renderCart() }
              </div>
            </Div>
          </section>
          {featuredProduct && (
            <section
              className="section block-37 switchable"
            >
              <div className="container">
                <div className="row justify-content-around">
                  {/* starts, column right  */}
                  <div className="col-md-5 col-lg-5">
                    <h2 style={{ color: website.primary_color }}>
                      {featuredProduct.productName}
                    </h2>
                    <div className="text-block d-flex align-items-center pb-3">
                      {this._renderPrice(featuredProduct)}
                      {featuredProduct.on_sale && (
                        <span className="label position-static product-sale-price">
                          Sale
                        </span>
                      )}
                    </div>
                    <div
                      className="lead pre"
                      style={{ color: website.secondary_color }}
                      dangerouslySetInnerHTML={{
                        __html: featuredProduct.productDescription,
                      }}
                    />
                    <div>
                      {
                        showAddCart ?
                          <a
                            className="btn btn--secondary mb-2 w-100"
                            onClick={() =>this.props.onAddToCartPressed(featuredProduct, null, [], quantity)}
                          >
                            <span className="btn__text">{cartButtonText}</span>
                          </a>
                        :
                          <a
                            className="btn btn--secondary mb-2 w-100"
                            href={productUrl}
                            onClick={() => {
                              General.setLocationHref(productUrl)
                            }}
                          >
                            <span className="btn__text">More Details</span>
                          </a>
                      }
                    </div>
                  </div>
                  <div className="col-md-7 col-lg-6">
                    <div className="position-relative">
                      <div
                        key={key}
                        className="slider border--round boxed--border"
                        data-paging="true"
                        data-arrows="true"
                      >
                        <ul className="slides">
                          {images.map((image) => {
                            return (
                              <li
                                key={image.id}
                                style={{
                                  backgroundImage:
                                    "url(" + getImageUrl(image, 37) + ")",
                                }}
                              ></li>
                            );
                          })}
                        </ul>
                      </div>
                      <BadgeBlock product={featuredProduct} />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {
            website.extra.product_page_settings.cart_page_html &&
            <>
              {
                website.extra.product_page_settings.cart_page_html_lazy_load &&
                <InView
                  triggerOnce={true}
                  key={key}
                >
                  {({ inView, ref, entry }) => (
                    <div ref={ref}>
                      { inView &&
                        <SafeHtml html={website.extra.product_page_settings.cart_page_html}/>
                      }
                    </div>
                  )}
                </InView>
              }

              {
                !website.extra.product_page_settings.cart_page_html_lazy_load &&
                <section className="block-54 text-center" key={key}>
                  <div className="container">
                    <SafeHtml html={website.extra.product_page_settings.cart_page_html}/>
                  </div>
                </section>
              }
            </>
          }
        </div>
        {this._renderProductSettingsButton()}
        <ProductSettingsModal
          show={this.state.showProductSettingsModal}
          website={website}
          onCheckoutTypeUpdated={(checkoutType) => {
            website.checkout_type = checkoutType
            this._update(website)
          }}
          onUpdated={(data) => {
            if(!website.extra){
              website.extra = {product_page_settings: null}
            }
            website.extra.product_page_settings = data
            this._update(website, () => this._setup())
          }}
          onHide={() => this.setState({showProductSettingsModal: false})}
        />
        <div id="notification-container" class="text-center">
          <div id="notification-content"></div>
        </div>
        {this._renderPopupManagerModal()}
        {!this.state.showPopupManagerModal && <StorefrontPopupWrapper
            updateCart={(cart) => {
              this.setState({ cart });
              this.props.onUpdatedCart(cart);
            }}
            editableProp={this.state.editable}
            website={website}
          />
        }
      </>
    )
  }
}
